module.exports = __webpack_public_path__ + "images/emoji/water_buffalo.68d1e4e93e31b001a651.png";